/**
 * Comu Blog – Listing Page Interactions
 * - Media Coverage Carousel + List sync
 * - Category Filter Tabs
 * - Client-side Pagination
 */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-blog-module]');
    if (!root) return;
    initMediaCarousel(root);
    initBlogFilter(root);
  }

  /* ======================================================================
     1. Media Coverage Carousel + List
     ====================================================================== */
  function initMediaCarousel(root) {
    var carousel = root.querySelector('[data-media-carousel]');
    var listWrap = root.querySelector('[data-media-list]');
    if (!carousel || !listWrap) return;

    var slides = carousel.querySelectorAll('[data-slide-index]');
    var items = listWrap.querySelectorAll('[data-media-index]');
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    var total = slides.length;
    if (!total) return;

    var activeIndex = 0;
    var timer = null;
    var isProgrammaticScroll = false;

    var style = getComputedStyle(root);
    var delayStr = style.getPropertyValue('--cb-carousel-delay');
    var delay = parseInt(delayStr, 10) || 5400;

    function setSlide(index, userInitiated) {
      clearTimeout(timer);

      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      activeIndex = index;

      for (var i = 0; i < slides.length; i++) {
        if (i === activeIndex) {
          slides[i].classList.add('is-active');
        } else {
          slides[i].classList.remove('is-active');
        }
      }

      for (var j = 0; j < items.length; j++) {
        if (j === activeIndex) {
          items[j].classList.remove('is-active');
          void items[j].offsetWidth;
          items[j].classList.add('is-active');
          items[j].setAttribute('aria-selected', 'true');
          scrollItemIntoView(items[j], userInitiated);
        } else {
          items[j].classList.remove('is-active');
          items[j].setAttribute('aria-selected', 'false');
        }
      }

      timer = setTimeout(function () { setSlide(activeIndex + 1); }, delay);
    }

    function scrollItemIntoView(item, userInitiated) {
      if (!listWrap) return;
      var isMobile = window.innerWidth <= 990;

      if (isMobile) {
        var listRect = listWrap.getBoundingClientRect();
        var itemRect = item.getBoundingClientRect();
        var offsetDiff = itemRect.left - listRect.left;
        if (Math.abs(offsetDiff) > 5) {
          isProgrammaticScroll = true;
          var target = listWrap.scrollLeft + offsetDiff;
          var origSnap = listWrap.style.scrollSnapType;
          listWrap.style.scrollSnapType = 'none';
          listWrap.scrollTo({ left: target, behavior: 'smooth' });
          setTimeout(function () {
            listWrap.style.scrollSnapType = origSnap;
            isProgrammaticScroll = false;
          }, 500);
        }
      } else if (!userInitiated) {
        var cTop = listWrap.scrollTop;
        var cBottom = cTop + listWrap.clientHeight;
        var wrapTop = listWrap.getBoundingClientRect().top;
        var elTop = item.getBoundingClientRect().top;
        var elemTop = elTop - wrapTop + cTop;
        var elemBottom = elemTop + item.getBoundingClientRect().height;

        if (elemTop < cTop) {
          listWrap.scrollTo({ top: elemTop - 20, behavior: 'smooth' });
        } else if (elemBottom > cBottom) {
          listWrap.scrollTo({ top: elemBottom - listWrap.clientHeight + 20, behavior: 'smooth' });
        }
      }
    }

    // Arrow buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        setSlide(activeIndex - 1, true);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        setSlide(activeIndex + 1, true);
      });
    }

    // Media list item clicks
    for (var k = 0; k < items.length; k++) {
      (function (idx) {
        items[idx].addEventListener('click', function () {
          if (activeIndex === idx) {
            var url = this.getAttribute('data-review-url');
            if (url) window.open(url, '_blank');
          } else {
            setSlide(idx, true);
          }
        });
      })(k);
    }

    // Desktop: wheel passthrough at scroll edges
    listWrap.addEventListener('wheel', function (e) {
      if (window.innerWidth <= 990) return;
      var st = listWrap.scrollTop;
      var sh = listWrap.scrollHeight;
      var ch = listWrap.clientHeight;
      var d = e.deltaY;
      if ((d < 0 && st <= 0) || (d > 0 && st + ch >= sh - 1)) {
        window.scrollBy(0, d);
      }
    }, { passive: true });

    // Visibility change: pause/resume
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearTimeout(timer);
      } else {
        setSlide(activeIndex);
      }
    });

    // Mobile: scroll-sync media list → carousel
    var scrollDebounce = null;
    var isScrollSyncing = false;
    listWrap.addEventListener('scroll', function () {
      if (window.innerWidth > 990 || isScrollSyncing || isProgrammaticScroll) return;
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(function () {
        if (isProgrammaticScroll) return;
        var listRect = listWrap.getBoundingClientRect();
        var closestIdx = 0;
        var minDiff = Infinity;
        for (var i = 0; i < items.length; i++) {
          var diff = Math.abs(items[i].getBoundingClientRect().left - listRect.left);
          if (diff < minDiff) {
            minDiff = diff;
            closestIdx = i;
          }
        }
        if (closestIdx !== activeIndex) {
          isScrollSyncing = true;
          setSlide(closestIdx, true);
          setTimeout(function () { isScrollSyncing = false; }, 350);
        }
      }, 120);
    }, { passive: true });

    // Touch swipe on carousel
    var touchStartX = 0;
    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    carousel.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(diff) > 45) {
        setSlide(activeIndex + (diff < 0 ? 1 : -1), true);
      }
    }, { passive: true });

    // Hover pause/resume on carousel
    carousel.addEventListener('pointerenter', function () { clearTimeout(timer); });
    carousel.addEventListener('pointerleave', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { setSlide(activeIndex + 1); }, delay);
    });

    // Initial
    setSlide(0);
  }

  /* ======================================================================
     2. Category Filter + Client-side Pagination
     ====================================================================== */
  function initBlogFilter(root) {
    var filterBtns = root.querySelectorAll('[data-filter]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tags]'));
    var pager = root.querySelector('[data-blog-pager]');
    var insightsSection = root.querySelector('[data-blog-insights]');
    if (!cards.length) return;

    var currentFilter = 'all';
    var currentPage = 1;

    var mql = window.matchMedia('(max-width: 768px)');

    function getPerPage() {
      return mql.matches ? 6 : 9;
    }

    function getMatchingCards() {
      if (currentFilter === 'all') return cards;
      return cards.filter(function (card) {
        var tags = (card.getAttribute('data-tags') || '').split(',');
        return tags.indexOf(currentFilter) !== -1;
      });
    }

    function render(scrollToTop) {
      var perPage = getPerPage();
      var matching = getMatchingCards();
      var totalPages = Math.max(1, Math.ceil(matching.length / perPage));

      if (currentPage > totalPages) currentPage = totalPages;
      if (currentPage < 1) currentPage = 1;

      var startIdx = (currentPage - 1) * perPage;
      var endIdx = startIdx + perPage;
      var activeSet = [];
      for (var i = startIdx; i < endIdx && i < matching.length; i++) {
        activeSet.push(matching[i]);
      }

      cards.forEach(function (card) {
        if (activeSet.indexOf(card) !== -1) {
          card.removeAttribute('hidden');
          if (scrollToTop) {
            card.style.opacity = '0';
            card.style.transform = 'translateY(8px)';
            setTimeout(function () {
              card.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
              card.style.opacity = '1';
              card.style.transform = 'translateY(0)';
            }, 15);
          } else {
            card.style.opacity = '1';
            card.style.transform = 'translateY(0)';
          }
        } else {
          card.setAttribute('hidden', '');
        }
      });

      renderPager(totalPages);

      if (scrollToTop && insightsSection) {
        var offset = 80;
        var pos = insightsSection.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: Math.max(0, pos - offset), behavior: 'smooth' });
      }
    }

    function renderPager(totalPages) {
      if (!pager) return;
      if (totalPages <= 1) {
        pager.setAttribute('hidden', '');
        return;
      }
      pager.removeAttribute('hidden');
      pager.innerHTML = '';

      // Prev arrow
      var prevArrow = document.createElement('button');
      prevArrow.type = 'button';
      prevArrow.className = 'cb-pager__arrow';
      prevArrow.setAttribute('aria-label', 'Previous page');
      prevArrow.disabled = currentPage <= 1;
      prevArrow.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"></polyline></svg>';
      prevArrow.addEventListener('click', function () {
        if (currentPage > 1) { currentPage--; render(true); }
      });
      pager.appendChild(prevArrow);

      // Page numbers
      for (var i = 1; i <= totalPages; i++) {
        (function (page) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'cb-pager__btn' + (page === currentPage ? ' is-active' : '');
          btn.setAttribute('aria-label', 'Page ' + page);
          btn.textContent = String(page);
          btn.addEventListener('click', function () {
            if (currentPage !== page) { currentPage = page; render(true); }
          });
          pager.appendChild(btn);
        })(i);
      }

      // Next arrow
      var nextArrow = document.createElement('button');
      nextArrow.type = 'button';
      nextArrow.className = 'cb-pager__arrow';
      nextArrow.setAttribute('aria-label', 'Next page');
      nextArrow.disabled = currentPage >= totalPages;
      nextArrow.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"></polyline></svg>';
      nextArrow.addEventListener('click', function () {
        if (currentPage < totalPages) { currentPage++; render(true); }
      });
      pager.appendChild(nextArrow);
    }

    // Filter button clicks
    for (var f = 0; f < filterBtns.length; f++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          currentFilter = this.getAttribute('data-filter');
          currentPage = 1;

          for (var b = 0; b < filterBtns.length; b++) {
            if (filterBtns[b].getAttribute('data-filter') === currentFilter) {
              filterBtns[b].classList.add('is-active');
            } else {
              filterBtns[b].classList.remove('is-active');
            }
          }

          render(false);

          // Scroll filter bar to center the clicked button
          var bar = this.closest('[data-blog-filters]');
          if (bar) {
            var barRect = bar.getBoundingClientRect();
            var btnRect = this.getBoundingClientRect();
            var delta = (btnRect.left - barRect.left) - (barRect.width / 2) + (btnRect.width / 2);
            bar.scrollBy({ left: delta, behavior: 'smooth' });
          }
        });
      })(filterBtns[f]);
    }

    // Responsive: re-render when crossing breakpoint
    var lastPerPage = getPerPage();
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var newPerPage = getPerPage();
        if (newPerPage !== lastPerPage) {
          lastPerPage = newPerPage;
          render(false);
        }
      }, 150);
    });

    // Initial render
    render(false);
  }

  /* ======================================================================
     Bootstrap
     ====================================================================== */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
